import { createFileRoute, redirect } from '@tanstack/react-router';

import { MembershipsCatalog } from '../modules/MembershipsCatalog';
import { membershipAdminCheck } from '../tools/permissionChecks';

export const Route = createFileRoute('/admin/memberships-catalog')({
  component: RouteComponent,
  // Plan and price editing, reached from a button on the Memberships page. That page is open to
  // all staff, so the catalog carries its own gate rather than relying on being hard to find.
  loader(ctx) {
    if (!membershipAdminCheck(ctx.context.authContext.user)) {
      throw redirect({ to: '/memberships' });
    }
  },
  head() {
    return {
      meta: [{ title: 'Memberships Admin' }],
    };
  },
});

function RouteComponent() {
  return <MembershipsCatalog />;
}
